import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 30000 });

const ADMIN_KEY = "ejpr_admin_key";
export const getAdminKey = () => sessionStorage.getItem(ADMIN_KEY) || "";
export const setAdminKey = (k) => (k ? sessionStorage.setItem(ADMIN_KEY, k) : sessionStorage.removeItem(ADMIN_KEY));
const adminHeaders = () => ({ headers: { "X-Admin-Key": getAdminKey() } });

export const errorMessage = (e, fallback = "Something went wrong. Please try again.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg.replace(/^Value error, /, "");
  return fallback;
};

// Public
export const fetchStories = (params = {}) => http.get("/stories", { params }).then((r) => r.data);
export const fetchStory = (slug) => http.get(`/stories/${slug}`).then((r) => r.data);
export const submitStory = (payload) => http.post("/stories", payload).then((r) => r.data);
export const sendContact = (payload) => http.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => http.post("/newsletter", { email }).then((r) => r.data);

// Admin
export const adminLogin = (password) => http.post("/admin/login", { password }).then((r) => r.data);
export const adminListStories = (status) => http.get("/admin/stories", { params: status ? { status } : {}, ...adminHeaders() }).then((r) => r.data);
export const adminSetStatus = (id, status) => http.patch(`/admin/stories/${id}`, { status }, adminHeaders()).then((r) => r.data);
export const adminDeleteStory = (id) => http.delete(`/admin/stories/${id}`, adminHeaders()).then((r) => r.data);
